<section class="lp-countries-hero-jumbotron">
  <div class="row">
    <div class="col-12">
      <div class="shop-and-ship-why-choose-shippn-wrapper">
        <div class="reason-for-choose-shippn">
          <img
            src="assets/img/lp-countries/why-choose-shippn/worldwide-shipping.png"
            alt=""
          />
          <strong>Shop From 36+ Countries</strong>
          <p>
            Access retailers worldwide that don't ship to <strong><span *ngIf="activeCountry?.country_name === 'United States of America' || activeCountry?.country_name === 'United Kingdom'"> the </span>{{activeCountry.country_name}}</strong>
          </p>
        </div>

        <div class="reason-for-choose-shippn">
          <img
            src="assets/img/lp-countries/why-choose-shippn/foreign-address.png"
            alt=""
          />
          <strong>Foreign Address FOR FREE</strong>
          <p>
            Get shipping addresses in <span *ngIf="activeCountry?.country_route !== 'united-states-of-america'">the USA</span> <span *ngIf="activeCountry?.country_route === 'united-states-of-america'">France</span>, <span *ngIf="activeCountry?.country_route !== 'united-kingdom'">the UK</span> <span *ngIf="activeCountry?.country_route === 'united-kingdom'">Canada</span>, <span *ngIf="activeCountry?.country_route !== 'japan'">Japan</span> <span *ngIf="activeCountry?.country_route === 'japan'">Singapore</span>, <span *ngIf="activeCountry?.country_route !== 'germany'">Germany</span> <span *ngIf="activeCountry?.country_route === 'germany'">Netherlands</span>, <span *ngIf="activeCountry?.country_route !== 'italy'">Italy</span> <span *ngIf="activeCountry?.country_route === 'italy'">Spain</span> and more <strong>for free</strong>
          </p>
        </div>

        <div class="reason-for-choose-shippn">
          <img
            src="assets/img/lp-countries/why-choose-shippn/credit-card.png"
            alt=""
          />
          <strong>No Foreign Credit Card Needed</strong>
          <p>
            We handle payments for you with our
            <strong>Buy For Me service </strong>
          </p>
        </div>

        <div class="reason-for-choose-shippn">
          <img
            src="assets/img/lp-countries/why-choose-shippn/fast-delivery.png"
            alt=""
          />
          <strong>Fast Delivery</strong>
          <p>
            Receive your packages in <strong><span *ngIf="activeCountry?.country_name === 'United States of America' || activeCountry?.country_name === 'United Kingdom'"> the </span>{{activeCountry.country_name}}</strong> within <strong>1-7 business days</strong>
          </p>
        </div>
        <div class="reason-for-choose-shippn">
          <img
            src="assets/img/lp-countries/why-choose-shippn/tracking-package.png"
            alt=""
          />
          <strong>Full Tracking</strong>
          <p>
            Monitor your shipment from purchase to delivery
          </p>
        </div>
        <div class="reason-for-choose-shippn">
          <img
            src="assets/img/lp-countries/why-choose-shippn/customs-handling.png"
            alt=""
          />
          <strong>Customs Handling</strong>
          <p>
            We manage all import documentation for smooth delivery
          </p>
        </div>
        <div class="reason-for-choose-shippn">
          <img
            src="assets/img/lp-countries/why-choose-shippn/package-consolidation.png"
            alt=""
          />
          <strong>Package Consolidation</strong>
          <p>
            Combine multiple purchases to save on shipping costs
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
